import { PortalOccurrenceResponse } from "../contracts/PortalOccurrenceResponse";
import { PortalOccurrence } from "../models/PortalOccurrence";

export class PortalOccurrenceResponseMapper {
  /**
   * Converts a PortalOccurrenceResponse to the UI model, trimming the wire
   * time (HH:mm:ss) to HH:mm.
   */
  toItem = (resp: PortalOccurrenceResponse): PortalOccurrence => ({
    bookingId: resp.bookingId,
    title: resp.title,
    date: resp.date,
    time: resp.time.split(":").slice(0, 2).join(":"),
    timeZone: resp.timeZone,
    durationMinutes: resp.durationMinutes,
    isCancelled: resp.isCancelled,
    seatStatus: resp.seatStatus ?? null,
    canCancel: resp.canCancel ?? false,
    cancelledVisitStatus: resp.cancelledVisitStatus ?? null,
    lateCancellationFee: resp.lateCancellationFee
      ? { amountMinorUnits: resp.lateCancellationFee.amountMinorUnits, currency: resp.lateCancellationFee.currency }
      : null,
    chargedAmount:
      resp.chargedAmountMinorUnits != null && resp.chargedCurrency
        ? { amountMinorUnits: resp.chargedAmountMinorUnits, currency: resp.chargedCurrency }
        : null,
  });

  toItems = (responses: PortalOccurrenceResponse[]): PortalOccurrence[] =>
    responses.map(this.toItem);
}
